function fullURL(path) {
  return `${process.env.VUE_APP_API_ROOT}/${path}`;
};

export default {
  login(context, user) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("users/login"), "POST", user)
      .then(response => {
        if (response.ok) return response.json();
        reject(response.status);
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  getAllUsers(context) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("users"), "GET")
      .then(response => {
        if (response.ok) return response.json();
        reject(response.status);
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  changePassword(context, form) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("users/changePassword"), "POST", form)
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  addUser(context, user) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("users/register-admin"), "POST", user)
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  addLegislation(context, legislation) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("legislations"), "POST", legislation)
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  deleteUser(context, id) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL(`users/${id}`), "DELETE")
      .then(response => {
        if (response.ok) return response.json();
        reject(response.status);
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  deleteItem(context, data) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL(`${data.path}/${data.id}`), "DELETE")
      .then(response => {
        if (response.ok) return response.json();
        reject(response.status);
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  getItems(context, data) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL(`${data.path}${data.filter ? "?filter=" + JSON.stringify(data.filter) : ""}`), "GET")
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  addItem(context, data) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL(`${data.path}${data.where ? "?where=" + JSON.stringify(data.where) : ""}`), "POST", data.data)
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  deleteSection(context, id) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL(`sections/${id}`), "DELETE")
      .then(response => {
        if (response.ok) return response.json();
        reject(response.status);
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  getAllLegislations(context) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("/legislations"), "GET")
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  getAllSections(context, legislationId) {

    return new Promise((resolve, reject) => {

      let filter = {
        where: {
          legislationId: legislationId
        }
      };

      this._vm.$fetch(fullURL(`/sections?filter=${JSON.stringify(filter)}`), "GET")
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  addSection(context, section) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("sections"), "POST", section)
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  addClause(context, clause) {

    return new Promise((resolve, reject) => {

      this._vm.$fetch(fullURL("clauses"), "POST", clause)
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  },

  getAllClauses(context, sectionId) {

    return new Promise((resolve, reject) => {

      let filter = {
        where: {
          sectionId: sectionId
        }
      };

      this._vm.$fetch(fullURL(`/clauses?filter=${JSON.stringify(filter)}`), "GET")
      .then(response => {

        if (response.ok) return response.json();
        reject(response.status);

      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });

    });

  }

};